export const gr = {
  nav: {
    story: "Ιστορία",
    gallery: "Φωτογραφίες",
    location: "Τοποθεσία",
    contact: "Επικοινωνία",
    home: "Αρχική",
    reserve: "Κράτηση",
  },
  hero: {
    tag: "Κιόνι · Ιθάκη · Ιόνιο Πέλαγος",
    headline_1: "Ένας ήσυχος κήπος",
    headline_2: "πάνω από το λιμάνι.",
    sub: "Μια γαλήνια θερινή κατοικία για επισκέπτες που ανταλλάσσουν τους γρήγορους ρυθμούς με τη σκιά μιας ελιάς και τον ήχο των τζιτζικιών στο σούρουπο.",
    cta_book: "Κρατήστε τη σεζόν",
    cta_learn: "Ανακαλύψτε τη βίλα",
  },
  story: {
    overline: "01 · Η Βίλα",
    heading: "Ένας τόπος για να επιβραδύνεις.",
    body_1: "Χτισμένη σε αναβαθμίδες πάνω από το ψαροχώρι του Κιονίου, η Ithaca Garden Villa είναι ένα ιδιωτικό καταφύγιο φτιαγμένο για την ησυχία. Οι μέρες κυλούν στον κήπο — κάτω από τις συκιές και τις ελιές, στη σκιαστή βεράντα, σε ένα ήσυχο αίθριο όπου η μόνη ενόχληση είναι ο ήχος των τζιτζικιών.",
    body_2: "Στο εσωτερικό, η βίλα ολοκληρώνεται με λεπτό γούστο: λινά υφάσματα, φυσική πέτρα, απαλά επιχρίσματα και μελετημένες λεπτομέρειες σε όλο το χώρο. Μία ιδιωτική κατοικία — ποτέ κοινόχρηστη — για όλη τη διάρκεια της διαμονής σας.",
    bedrooms: "Υπνοδωμάτια",
    guests: "Επισκέπτες",
    min_stay: "Ελάχιστη διαμονή",
    nights: "νύχτες",
    bedding: "Ένα διπλό κρεβάτι (queen) και δύο μονά — φιλοξενεί τέσσερις ανέτως. Επιπλέον κρεβάτια και μαξιλάρια διατίθενται κατόπιν αιτήματος με μικρή επιπλέον χρέωση.",
  },
  amenities: {
    overline: "02 · Παροχές",
    heading: "Τα ουσιώδη, μελετημένα.",
    items: [
      ["Σκιαστή βεράντα", "Μακροχρόνια γεύματα μακριά από τον μεσημεριανό ήλιο"],
      ["Εξωτερικός κήπος", "Συκιές, ελιές και εσπεριδοειδή σε αναβαθμίδες"],
      ["Εξωτερικό ντους", "Για να ξεπλύνετε τη θάλασσα"],
      ["Κλιματισμός", "Αθόρυβος, σε όλο το σπίτι"],
      ["Wi-Fi", "Οπτική ίνα σε όλη τη βίλα"],
      ["Χώρος εργασίας", "Εργονομικό γραφείο & καρέκλα Herman Miller"],
      ["Apple TV", "Streaming σε κάθε οθόνη"],
      ["Nespresso", "Φρέσκος espresso, από νωρίς"],
      ["Πλυντήριο ρούχων", "Στη βίλα, διακριτικά τοποθετημένο"],
      ["Διπλός χώρος στάθμευσης", "Ασφαλής, εκτός δρόμου, για δύο αυτοκίνητα"],
    ],
  },
  villa_reel: {
    overline: "Η Βίλα",
    heading: "Κάθε δωμάτιο, κάθε γωνία.",
    body: "Μια αργή περιήγηση στο σπίτι — από τα πέτρινα βεράντες και τις σκιερές αυλές με ελιές μέχρι τα ιδιωτικά υπνοδωμάτια και τις ήσυχες γωνιές ανάγνωσης. Γυρίστηκε και μοντάρθηκε από εμάς για να ξέρετε ακριβώς τι κλείνετε.",
    caption: "Ένα λεπτό μέσα στη Βίλα Κήπος της Ιθάκης",
  },
  films: {
    overline: "Σε κίνηση",
    heading: "Το νησί, από μια πιο ήρεμη οπτική.",
    body: "Ταινίες του λιμανιού του Κιονίου, της ακτογραμμής και της βίλας — κινούμενες εικόνες για να απολαύσετε πριν την άφιξή σας.",
  },
  urgency: {
    overline: "Διαθεσιμότητα",
    night_singular: "διανυκτέρευση",
    night_plural: "διανυκτερεύσεις",
    remaining_in: "διαθέσιμες τον",
    best_window: "Μεγαλύτερη διαθέσιμη περίοδος",
    from: "από",
    cta: "Κράτηση αυτών των ημερομηνιών",
  },
  location: {
    overline: "03 · Τοποθεσία",
    heading: "Δύο λεπτά με τα πόδια από τη θάλασσα.",
    body: "Η βίλα βρίσκεται σε μικρή απόσταση από το ημικυκλικό λιμάνι του Κιονίου, λίγα λεπτά με τα πόδια από τις ταβέρνες του χωριού και μόλις δύο λεπτά από τις πιο ήσυχες παραλίες του νησιού. Η άνεση και η ιδιωτικότητα σε αυτό το επίπεδο πολυτέλειας δεν συναντώνται πουθενά αλλού στο Κιόνι.",
    port: "Λιμάνι Κιονίου",
    airport: "Πλησιέστερο αεροδρόμιο",
    port_val: "5 λεπτά με τα πόδια",
    airport_val: "Κεφαλονιά · 2 ώρες",
    find_us_overline: "Βρείτε μας",
    address_line: "Κιόνι · Ιθάκη 28301 · Ελλάδα",
    coords: "38.4479° N, 20.6895° E",
    howto: {
      overline: "Πώς θα φτάσετε",
      heading: "Το ταξίδι προς την Ιθάκη.",
      intro: "Η ανταμοιβή της Ιθάκης είναι ότι δεν φτάνεις εύκολα — ήσυχα, χωρίς βιασύνη, με πρόθεση. Οι τρεις διαδρομές που προτείνουμε πιο συχνά.",
      routes: [
        {
          badge: "01",
          title: "Αεροπορικώς + πλοίο",
          duration: "Από Αθήνα · μισή μέρα",
          steps: [
            "Πτήση Αθήνα → Κεφαλονιά (Αργοστόλι) — περίπου 40 λεπτά.",
            "Αργοστόλι → λιμάνι Σάμης με ταξί ή ενοικιαζόμενο αυτοκίνητο (περίπου 45 λεπτά).",
            "Πλοίο Σάμη → Πίσω Αετός (περίπου 30 λεπτά) με Ionian Pelagos.",
            "Αεροπορικές γραμμές Αθήνα–Κεφαλονιά: Aegean, Olympic Air, EasyJet, Ryanair. Οι ώρες πτήσεων και πλοίων δεν συγχρονίζονται πάντα — ένα ιδιωτικό sea taxi είναι η κομψή λύση.",
          ],
        },
        {
          badge: "02",
          title: "Οδικώς + πλοίο",
          duration: "Από Αθήνα · μία μέρα",
          steps: [
            "Οδικώς Αθήνα → Κυλλήνη (~3 ώρες 25', 287 χλμ), πλοίο μέσω Πόρου προς Ιθάκη.",
            "Ή Αθήνα → Αστακός (~3 ώρες 52', 299 χλμ), πλοίο Αστακός → Βαθύ.",
            "Λεωφορεία ΚΤΕΛ καθημερινά από τον σταθμό Κηφισού με εισιτήρια πλοίου διαθέσιμα στο ίδιο ταμείο.",
          ],
        },
        {
          badge: "03",
          title: "Με ιδιωτικό sea taxi",
          duration: "Από Κεφαλονιά · ~30 λεπτά",
          steps: [
            "Για επισκέπτες που φτάνουν αργά ή εκτός δρομολογίου, το ιδιωτικό sea taxi από την Κεφαλονιά είναι η πιο γρήγορη και ευέλικτη επιλογή.",
            "Εταιρείες: Odysseas Sea Taxi, Ithaca Transfers (Καβαλλιεράτος), Zaharatos Sea Transfers.",
            "Το κανονίζουμε εμείς κατόπιν αιτήματος — γράψτε μας όταν επιβεβαιωθούν οι πτήσεις σας.",
          ],
        },
      ],
      ferries_heading: "Ακτοπλοϊκές εταιρείες",
      ferries: [
        ["Levante Ferries", "Πάτρα · Σάμη · Ιθάκη και Κυλλήνη · Πόρος · Ιθάκη"],
        ["Ionian Pelagos", "Αστακός · Κεφαλονιά · Ιθάκη"],
        ["Lefkada Palace", "Επιβατική γραμμή στα Ιόνια νησιά"],
      ],
      numbers_heading: "Χρήσιμα τηλέφωνα",
      numbers: [
        ["Κράτηση εισιτηρίων — Ιθάκη", "+30 26740 32104"],
        ["Κράτηση εισιτηρίων — Κεφαλονιά", "+30 26740 23405"],
        ["Κράτηση εισιτηρίων — Αστακός", "+30 26460 38020"],
        ["Λιμεναρχείο Πατρών", "+30 2610 341002"],
        ["Λιμεναρχείο Κυλλήνης", "+30 26230 92211"],
      ],
      note: "Τα δρομολόγια των πλοίων επηρεάζονται από τον καιρό — επιβεβαιώνετε πάντα την προηγούμενη ημέρα. Συντονίζουμε ευχαρίστως τη μεταφορά σας από οποιοδήποτε σημείο άφιξης στο Ιόνιο.",
      source: "Πληροφορίες ταξιδιού βασισμένες σε στοιχεία από το ithacagreece.com",
    },
  },
  testimonial: {
    tag: "Επισκέπτης, Καλοκαίρι 2025",
    quote: "«Ήρθαμε για μία εβδομάδα και μείναμε δύο. Είναι το πιο ήσυχο μέρος που έχω γνωρίσει, και το φως — το φως είναι αδύνατο να περιγραφεί.»",
    author: "— A. K. · Λονδίνο",
  },
  concierge: {
    overline: "Υπηρεσίες concierge, κατόπιν αιτήματος",
    heading: "Όλα τα υπόλοιπα, διακριτικά κανονισμένα.",
    body: "Η βίλα συνοδεύεται από τη γαλήνια φροντίδα της Στέλλας, της οικονόμου και concierge μας στο νησί. Από ένα ιδιωτικό δείπνο με κεριά στη βεράντα, μέχρι μια ημερήσια κρουαζιέρα με σκάφος — φροντίζει τις μικρές πολυτέλειες που κάνουν μια εβδομάδα στην Ιθάκη να μοιάζει αβίαστη. Γράψτε μας στην κράτηση, ή απαντήστε στο welcome email — η Στέλλα αναλαμβάνει από εκεί.",
    contact_line: "Τα αιτήματα καλύτερα να γίνονται λίγες ημέρες νωρίτερα, ώστε να βρούμε τον κατάλληλο σεφ, σκάφος ή θεραπευτή για τις ημερομηνίες σας.",
    instagram_line: "Ακολουθήστε τη σεζόν στο Instagram",
    instagram_recent: "Πρόσφατα από τον Κιόνι",
    services: [
      ["Ιδιωτικός σεφ", "Δείπνα στη βεράντα, πιατέλες θαλασσινών ή πλήρες μενού γευσιγνωσίας — από τα ψαρόβαρκα του Κιονίου και τους παραγωγούς του νησιού."],
      ["Ενοικίαση σκάφους", "Μισή ή ολόκληρη ημέρα προς Φισκάρδο, Μεγανήσι και τα κρυφά όρμια της Ιθάκης. Κλασικά καΐκια με καπετάνιο ή σύγχρονα σκάφη ημέρας."],
      ["Μασάζ & γιόγκα στη βίλα", "Χαλαρωτικό σουηδικό μασάζ, βαθιάς πίεσης, ή ιδιωτικό μάθημα γιόγκα στην αυγή, στη βεράντα του κήπου."],
      ["Προμήθεια τροφίμων εκ των προτέρων", "Το ψυγείο και το κελάρι πλήρως εφοδιασμένα σύμφωνα με τις προτιμήσεις σας — γλυκά, καφές, κρασί, φυσικά καλλυντικά."],
      ["Μεταφορές & sea taxi", "Υποδοχή στο αεροδρόμιο Κεφαλονιάς, ιδιωτικές μεταφορές και κράτηση sea taxi όταν τα πλοία δεν εξυπηρετούν."],
      ["Εκδρομές & ξεναγήσεις", "Περίπατοι στους ελαιώνες στο ηλιοβασίλεμα, γευστικές δοκιμές κρασιού στην Κεφαλονιά, ιδιωτική ξενάγηση στην Ιθάκη του Ομήρου."],
    ],
  },
  cta: {
    overline: "04 · Κράτηση",
    heading: "Κρατήστε το καλοκαίρι σας στον κήπο.",
    body: "Οι κρατήσεις γίνονται με σειρά προτεραιότητας. Η πληρωμή διασφαλίζεται μέσω Stripe. Η σεζόν διαρκεί από Μάιο έως Οκτώβριο, με ελάχιστη διαμονή {n} νύχτες.",
    button: "Ελέγξτε διαθεσιμότητα",
    from: "Από",
    per_night: "ανά νύχτα",
    cleaning: "Καθαριότητα €{n}",
    min: "Ελάχιστο {n} νύχτες",
    deposit: "Επιστρεπτέα εγγύηση €{n} · επιστρέφεται 3 ημέρες μετά την αναχώρηση",
  },
  newsletter: {
    overline: "Ήσυχη σεζόν, ιδιωτική λίστα",
    heading: "Το γράμμα από τον κήπο.",
    body: "Μία ή δύο φορές τον χρόνο, ένα σύντομο γράμμα από την Ιθάκη — πρώιμες κρατήσεις για το επόμενο καλοκαίρι, σπάνιες εβδομάδες ήσυχης σεζόν, σημειώσεις για τη συγκομιδή και τη θάλασσα.",
    email_placeholder: "το email σας",
    name_placeholder: "το όνομά σας (προαιρετικό)",
    submit: "Εγγραφή",
    success: "Ευχαριστούμε — είστε στη λίστα.",
    error: "Παρακαλώ εισάγετε ένα έγκυρο email.",
    consent: "Με την εγγραφή σας συμφωνείτε να λαμβάνετε περιστασιακά email από τον ιδιοκτήτη. Χωρίς κοινοποίηση στοιχείων, διαγραφή οποτεδήποτε.",
  },
  waitlist: {
    overline: "Αυτές οι ημερομηνίες είναι κλεισμένες",
    heading: "Εγγραφή στη λίστα αναμονής",
    body: "Εάν ένας επισκέπτης ακυρώσει ή η κράτησή του λήξει, θα σας στείλουμε email τη στιγμή που η εβδομάδα σας θα ανοίξει. Ο πρώτος που θα απαντήσει, κλείνει.",
    name_label: "Όνομα",
    email_label: "Email",
    phone_label: "Τηλέφωνο",
    notes_label: "Σημειώσεις",
    name_placeholder: "το όνομά σας",
    email_placeholder: "το email σας",
    phone_placeholder: "το τηλέφωνό σας (προαιρετικό)",
    notes_placeholder: "οτιδήποτε να ξέρουμε (προαιρετικό)",
    flex_label: "Πόσο ευέλικτες είναι οι ημερομηνίες σας;",
    flex_none: "Μόνο αυτές οι ημερομηνίες",
    flex_3: "± 3 ημέρες",
    flex_7: "± 1 εβδομάδα",
    submit: "Ενημερώστε με αν αυτές ελευθερωθούν",
    success: "Είστε στη λίστα — θα σας γράψουμε τη στιγμή που η εβδομάδα σας θα είναι ελεύθερη.",
    already: "Είστε ήδη στη λίστα αναμονής για αυτές τις ημερομηνίες.",
    error: "Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά σύντομα.",
  },
  review: {
    overline: "Ένα σημείωμα από τον κήπο",
    heading: "Πώς ήταν η Ιθάκη;",
    body: "Μια ήσυχη, ιδιωτική αξιολόγηση — μια βαθμολογία, μια φράση που θα μοιραζόμασταν με μελλοντικούς επισκέπτες μόνο αν το επιθυμείτε, και τυχόν σκέψεις για το τι πρέπει να έχει η βίλα.",
    invalid: "Αυτός ο σύνδεσμος δεν είναι πλέον έγκυρος.",
    already: "Έχετε ήδη αφήσει ένα σημείωμα — ευχαριστούμε.",
    rating_label: "Πώς θα βαθμολογούσατε τη διαμονή σας;",
    display_label: "Δημοσίευση με ποιο όνομα;",
    display_placeholder: "Το μικρό σας όνομα, ή «Ανώνυμα»",
    quote_label: "Μια φράση για μελλοντικούς επισκέπτες (προαιρετικό)",
    quote_placeholder: "Τα πρωινά ήταν πιο αργά από όσα έχω περάσει εδώ και χρόνια.",
    quote_consent: "Επιτρέπετε τη δημοσίευση αυτής της φράσης (ως ανώνυμη ή με το μικρό όνομά σας).",
    private_label: "Ιδιωτικό σημείωμα προς τον ιδιοκτήτη (προαιρετικό — δεν δημοσιεύεται)",
    private_placeholder: "Οτιδήποτε θέλετε να ξέρουμε.",
    amenities_label: "Τι πρέπει να έχει η βίλα;",
    amenities_body: "Επιλέξτε οτιδήποτε θα θέλατε να βρείτε εδώ.",
    amenities_bedroom: "Επιπλέον υπνοδωμάτιο",
    amenities_parking: "Γκαράζ",
    amenities_pool: "Πισίνα",
    amenities_jacuzzi: "Τζακούζι",
    amenities_gym: "Μικρό γυμναστήριο",
    amenities_chef: "Ιδιωτικός σεφ κατόπιν παραγγελίας",
    amenities_breakfast: "Πρωινό στη βεράντα",
    amenities_other_label: "Οτιδήποτε άλλο",
    amenities_other_placeholder: "Ενοικίαση καγιάκ, βαρκάδα ηλιοβασιλέματος, οδηγός…",
    submit: "Αποστολή ιδιωτικού σημειώματος",
    success: "Ευχαριστούμε. Το σημείωμά σας μας έφτασε.",
    error: "Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά.",
  },
  contact: {
    overline: "05 · Ερώτηση",
    heading: "Μιλήστε απευθείας με τον ιδιοκτήτη.",
    body: "Για ειδικές διαμονές, ιδιωτικές εκδηλώσεις ή απορίες σχετικά με τη βίλα — γράψτε μας και θα σας απαντήσουμε εντός 24 ωρών.",
    name: "Όνομα",
    email: "Email",
    phone: "Τηλέφωνο (προαιρετικό)",
    message: "Μήνυμα",
    submit: "Αποστολή",
    sending: "Αποστέλλεται…",
    success: "Ευχαριστούμε — θα επικοινωνήσουμε σύντομα.",
    error: "Αδυναμία αποστολής. Δοκιμάστε ξανά.",
  },
  booking: {
    overline: "Κρατήσεις",
    heading: "Επιλέξτε ημερομηνίες.",
    sub: "Ελάχιστη διαμονή {n} νύχτες. Πληρωμή μέσω Stripe. Οι γκρι ημερομηνίες δεν είναι διαθέσιμες.",
    select_stay: "Επιλέξτε τη διαμονή σας",
    checkin: "Άφιξη",
    checkout: "Αναχώρηση",
    nights: "Νύχτες",
    guests: "Επισκέπτες",
    guest_details: "Στοιχεία επισκέπτη",
    full_name: "Ονοματεπώνυμο",
    email: "Email",
    phone: "Τηλέφωνο",
    notes: "Σημειώσεις (προαιρετικό)",
    summary: "Σύνοψη κράτησης",
    cleaning_fee: "Καθαριότητα",
    deposit: "Επιστρεπτέα εγγύηση ζημιών",
    deposit_note: "Η εγγύηση των €390 επιστρέφεται εντός 3 ημερών από την αναχώρηση, εφόσον δεν υπάρχουν ζημιές.",
    total: "Σύνολο",
    select_prompt: "Επιλέξτε ημερομηνίες για να δείτε την τιμή.",
    pay: "Πληρωμή & Κράτηση",
    redirecting: "Ανακατεύθυνση…",
    secured: "Ασφαλής πληρωμή μέσω Stripe · Χωρίς χρέωση κράτησης",
    referral_title: "Κωδικός σύστασης (προαιρετικό)",
    referral_off: "έκπτωση",
    referral_remove: "Αφαίρεση",
    referral_placeholder: "IGV-XXXXXX",
    referral_apply: "Εφαρμογή",
    referral_hint: "Φίλοι που έμειναν εδώ μπορούν να μοιραστούν έναν κωδικό — €150 έκπτωση στη διαμονή σας.",
    referral_line: "Σύσταση",
  },
  success: {
    tag_ok: "Επιβεβαιωμένη",
    tag_pending: "Επεξεργασία",
    heading_ok: "Η κράτησή σας επιβεβαιώθηκε.",
    heading_pending: "Επιβεβαίωση πληρωμής…",
    heading_await: "Αναμονή επιβεβαίωσης.",
    guest: "Επισκέπτης",
    booking: "Κράτηση",
    total_paid: "Σύνολο",
    body: "Η απόδειξη έχει σταλεί στο email σας από το Stripe. Θα επικοινωνήσουμε με τις λεπτομέρειες άφιξης πριν τη διαμονή σας.",
    back: "Επιστροφή στη βίλα",
  },
  cancel: {
    tag: "Ακύρωση",
    heading: "Η πληρωμή ακυρώθηκε.",
    body: "Δεν έγινε καμία χρέωση. Οι ημερομηνίες παραμένουν διαθέσιμες — επιστρέψτε στη σελίδα κράτησης για να δοκιμάσετε ξανά.",
    retry: "Δοκιμάστε ξανά",
    home: "Αρχική",
  },
  footer: {
    tagline: "Γαλήνιο κήπος-καταφύγιο πάνω από το λιμάνι του Κιονίου. Διαθέσιμη μόνο τη θερινή σεζόν με απευθείας κράτηση.",
    contact: "Επικοινωνία",
    discover: "Ανακαλύψτε",
    elsewhere: "Θα μας βρείτε επίσης",
    home: "Αρχική",
    reserve: "Κράτηση",
    owner_login: "Σύνδεση ιδιοκτήτη",
    guest_portal: "Πύλη επισκεπτών",
    location_val: "Κιόνι, Ιθάκη",
    location_country: "Ιόνιο Πέλαγος, Ελλάδα",
    rights: "Με επιφύλαξη παντός δικαιώματος.",
    subtitle: "Ιδιωτικές ενοικιάσεις · Ιόνιο",
    photo_credits: "Προσωρινές φωτογραφίες του Κιονίου από το Wikimedia Commons (CC BY-SA)",
  },
};
